import HELPER from '@/app/utils/HELPER';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';

(function (jQuery) {
  jQuery.gfMetaSelector = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let $productMeta;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
      $productMeta = $gryffBody.find('#m-' + moduleId);

      if ($productMeta.length > 0 && $productMeta.attr('data-label') == '(P) Meta') {
        const metaKey =
          $productMeta.children('.module').attr('data-meta') != 'auto'
            ? $productMeta.children('.module').attr('data-meta')
            : $productMeta.attr('data-id');
        if ($productMeta.children('.module').attr('data-meta') == 'auto') {
          // set atribute
          $element.val(metaKey).attr('data-value', metaKey).attr('default_value', metaKey);

          let $settings = '';
          let fields = [];

          try {
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          for (let i = 0; i < fields.length; i++) {
            if (fields[i].name == 'meta') {
              fields[i].default_value = metaKey;
            }
            break;
          }
          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          app.$store.commit('editor/SET_DATA_SETTINGS', {
            id: keySettings,
            value: JSON.stringify(fields),
          });
        }
      }

      let delayType;
      $element.off('paste keyup').on('paste keyup', function () {
        clearTimeout(delayType);
        const oldMetaKey = $element.attr('data-value');

        delayType = setTimeout(function () {
          const newMetaKey = $element.val();

          _this.updateMetaKey(oldMetaKey, newMetaKey);

          $element.attr('value', newMetaKey).val(newMetaKey).trigger('input-change');
        }, 500);
        return false;
      });
    };

    this.updateMetaKey = function (oldMetaKey, newMetaKey) {
      const $product = $productMeta.closest('[data-label="Product"]');
      const productId = $product.children('.module').attr('data-pid');
      const productData = HELPER.searchProductInList(productId);

      if (
        productData.metafields != undefined &&
        productData.metafields.gempages != undefined &&
        productData.metafields.gempages[oldMetaKey] != undefined
      ) {
        productData.metafields.gempages[newMetaKey] = productData.metafields.gempages[oldMetaKey];
        productData.metafields.gempages[newMetaKey + '_bk'] = productData.metafields.gempages[oldMetaKey + '_bk'];

        delete productData.metafields.gempages[oldMetaKey];
        delete productData.metafields.gempages[oldMetaKey + '_bk'];
      }
      return productData.metafields.gempages[newMetaKey];
    };

    this.init();
  };

  jQuery.fn.gfMetaSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfmetaselector')) {
        const plugin = new jQuery.gfMetaSelector(this, options);
        jQuery(this).data('gfmetaselector', plugin);
      }
    });
  };
})(jQuery);
